import animation from '@helpers/animation';
import { imageUrl } from '@helpers/image';
import { useInView } from '@hooks/useInView';
import { LinkButton } from '@stories/Components/Buttons/GeneralButton/Button';
import ChatButton from '@stories/Components/ChatButton/ChatButton';
import ImageMask from '@stories/Components/ImageMask/ImageMask';
import LottieAnimation from '@stories/Components/LottieAnimation/LottieAnimation';
import Modal from '@stories/Components/Modal/Modal';
import * as React from 'react';
import ReactPlayer from 'react-player';
import S from './SplitContent.styles';
import { createAnchor } from '@helpers/text';
const SplitContent = ({ bgColor, bgColorAccent, chatBtn, content, cta, image, layout = 'image-left', lottie, mask, tag, title, video, videoMode = 'inline', pageContext, componentTheme = 0 /* Default */, }) => {
    const [showVideo, setShowVideo] = React.useState(false);
    const [refInView, inView] = useInView({
        rootMargin: animation.inView.rootMargin,
    }, false, pageContext?.isEditMode);
    return (React.createElement(S.Container, { ref: refInView, padding: true, "data-bg-color": bgColor, "data-bg-color-accent": bgColorAccent, "data-layout": layout, "data-theme": componentTheme },
        React.createElement(S.Inner, { "data-is-active": inView },
            bgColorAccent && React.createElement(S.BackgroundAccent, { "aria-hidden": true }),
            !showVideo && image && (React.createElement(S.ImageWrapper, null,
                mask === undefined && (React.createElement(S.Image, { alt: image.altText ?? '', loading: "lazy", role: image.altText ? undefined : 'presentation', src: imageUrl(image, { width: 860, height: 574 }), srcSet: [
                        `${imageUrl(image, { width: 860, height: 574 })} 1x`,
                        `${imageUrl(image, { width: 1290, height: 861 })} 1.5x`,
                        `${imageUrl(image, { width: 1720, height: 1148 })} 2x`,
                    ].join(', '), width: "860", height: "574" })),
                mask === 'mirror-portrait' && (React.createElement(React.Fragment, null,
                    React.createElement(S.MirrorPortraitOuter, null),
                    React.createElement(ImageMask, { mask: mask },
                        React.createElement(S.Image, { alt: image.altText ?? '', loading: "lazy", role: image.altText ? undefined : 'presentation', src: imageUrl(image, { width: 560, height: 695 }), srcSet: [
                                `${imageUrl(image, { width: 560, height: 695 })} 1x`,
                                `${imageUrl(image, { width: 840, height: 1042 })} 1.5x`,
                                `${imageUrl(image, { width: 1120, height: 1390 })} 2x`,
                            ].join(', '), width: "560", height: "695" })))),
                mask === 'curtains' && (React.createElement(React.Fragment, null,
                    React.createElement(S.CurtainOuter, null),
                    React.createElement(ImageMask, { mask: mask },
                        React.createElement(S.Image, { alt: image.altText ?? '', loading: "lazy", role: image.altText ? undefined : 'presentation', src: imageUrl(image, { width: 695, height: 695 }), srcSet: [
                                `${imageUrl(image, { width: 695, height: 695 })} 1x`,
                                `${imageUrl(image, { width: 1042, height: 1042 })} 1.5x`,
                                `${imageUrl(image, { width: 1390, height: 1390 })} 2x`,
                            ].join(', '), width: "695", height: "695" })))),
                video && (React.createElement(S.PlayButton, { "aria-label": "Play Video", onClick: (event) => {
                        event.preventDefault();
                        setShowVideo(true);
                    } },
                    React.createElement(S.PlayIcon, null))))),
            showVideo && video && videoMode === 'inline' && (React.createElement(S.VideoWrapper, null,
                React.createElement(ReactPlayer, { playing: showVideo, url: video, width: "100%", height: "100%", style: { position: 'absolute' }, controls: true }))),
            video && videoMode === 'modal' && (React.createElement(Modal, { isOpen: showVideo, onRequestClose: () => setShowVideo(false) },
                React.createElement(ReactPlayer, { playing: showVideo, url: video, width: "100%", height: "100%", style: { position: 'absolute' }, controls: true }))),
            lottie && (React.createElement(S.LottieWrapper, null,
                React.createElement(LottieAnimation, { src: lottie }))),
            React.createElement(S.ContentWrapper, null,
                tag && React.createElement(S.Tag, null, tag),
                React.createElement(S.Title, { id: createAnchor(title), "data-has-chat": chatBtn ? true : false }, title),
                content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
                cta?.text && (React.createElement(S.CtaWrapper, null,
                    React.createElement(LinkButton, { branding: getButtonBranding(), href: cta.url, target: cta.target, title: cta.text }))),
                chatBtn && (React.createElement(S.CtaWrapper, null,
                    React.createElement(ChatButton, { chatBtnCloseText: chatBtn.chatBtnCloseText, chatBtnOpenText: chatBtn.chatBtnOpenText })))))));
    function getButtonBranding() {
        // @todo:
        // Not in design but feels like a specific branded button should be
        // used depending on the bg accent.
        switch (bgColorAccent) {
            case 'plum':
                return 'primary';
            case 'sage':
                return 'primary';
            case 'toast':
                return 'primary';
            default:
                return 'primary';
        }
    }
};
export default SplitContent;
